// extracted by mini-css-extract-plugin
export var active = "_fm-7";
export var blink = "_fm-8";
export var dropDownSelector = "_fm-4";
export var dropDownWrapper = "_fm-3";
export var fakeCursor = "_fm-6";
export var fontSizeButton = "_fm-9";
export var formQuillEditor = "_fm-0";
export var pressed = "_fm-a";
export var qlBlank = "_fm-1";
export var textFormattingToolbar = "_fm-2";
export var textToolbarOption = "_fm-5";